<template>
	<div class="row">
		<div class="col-12 mb-3">
			<label class="text-muted">Hotel*</label>
			<select class="form-control" v-model="info.confhotel">
				<option v-for="hotel, index in confInfo.confhotel" :key="index">
					{{hotel}}
				</option>
			</select>
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Arrival Airline*</label>
			<select class="form-control" v-model="info.confairline1">
				<option v-for="airline in airlines" :value="airline.code" :key="airline.code">{{airline.name}}</option>
			</select>
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Flight Number*</label>
			<input type="text" class="form-control" v-model="info.confflight1" />
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Arrival Date*</label>
			<input type="date"  value="2022-04-03" min="2022-04-03" max="2022-04-08" class="form-control" v-model="info.confarrdate" />
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Arrival Time*</label>
			<input type="time" class="form-control" v-model="info.confarrtime" />
		</div>
		<div class="col-12">
			<hr/>
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Departure Airline*</label>
			<select class="form-control" v-model="info.confairline2">
				<option v-for="airline in airlines" :value="airline.code" :key="airline.code">{{airline.name}}</option>
			</select>
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Flight Number*</label>
			<input type="text" class="form-control" v-model="info.confflight2" />
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Departure Date*</label>
			<input type="date"  value="2022-04-09" min="2022-04-08" max="2022-04-11" class="form-control" v-model="info.confdepdate" />
		</div>
		<div class="col-12 col-md-6 mb-3">
			<label class="text-muted">Departure Time*</label>
			<input type="time" class="form-control" v-model="info.confdeptime" />
		</div>

		<div class="col-12 mb-5" align="right">
			<button class="btn btn-primary btn-lg" :disabled="!isFormValid||isBusy" @click="btnContinueClick">
				<span v-show="!isBusy">Update Information</span>
				<div class="spinner-border text-light" role="status" v-show="isBusy">
					<span class="sr-only">Updating...</span>
				</div>
			</button>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const fb = require("../firebaseConfig")

export default {
	name: "FlightHotelForm",
	components: {

	},
	props:["orderData"],
    computed:{
		confId(){
            return this.$store.state.confId
        },
        confName(){
            return this.$store.state.confName
        },
        confInfo(){
            return this.$store.state.confInfo
        },
        confList(){
			return this.$store.state.confList
        },
        confData(){
            return Array.isArray(this.confList) && this.confList.length > 0 ? this.confList.filter((c) => c.id === this.confId )[0].data : {}
        },
        filterTickets(){
            if(this.confTickets === "" && this.confPaymentStatus == "") return this.registrations;
			if(this.confTickets !== "" && this.confPaymentStatus !== ""){
				return this.registrations.filter((r) => r.data.confticketid === this.confTickets && r.data.status === this.confPaymentStatus);
			}else{
				if(this.confTickets !== "") return this.registrations.filter((r) => r.data.confticketid === this.confTickets);
				if(this.confPaymentStatus !== "") return this.registrations.filter((r) => r.data.status === this.confPaymentStatus);
			}

			return this.registrations;
        },
        userProfile(){
            console.log(this.$store.state.userProfileDoc)
            return this.$store.state.userProfile
        },
		isFormValid(){
			const {
				confhotel, confairline1, confairline2,
				confflight1, confflight2, confarrdate,
				confdepdate, confarrtime, confdeptime
			} = this.info

			if(!confhotel){
				return false;
			}
			if(!confairline1 || !confairline2 || !confflight1 || !confflight2){
				return false;
			}
			if(!confarrdate || !confarrtime || !confdepdate || !confdeptime){
				return false;
			}
            return true
        }
    },
    data(){
        return{
			isBusy: false,
			register:{},
			info: {
				confarrdate: "2022-04-03",
				confdepdate: "2022-04-08",
			},
			airlines:[
				{code: "CAL", name: "Caribbean Airlines"},
				{code: "JY", name: "interCaribbean Airways"},
				{code: "LIAT", name: "Liat"},
				{code: "SLM", name: "Surinam Airways"},
				{code: "BA", name: "British Airways"},
				{code: "AA", name: "American Airlines"},
				{code: "ACA", name: "Air Canada"},
				{code: "OTHER", name: "OTHER"},
			]
        }
    },
    methods:{
		btnContinueClick(){
			this.isBusy = true;
			const {orderData} = this;
			fb.ordersCollection.doc(this.orderData.id).update(this.info).then(()=>{
				Vue.$toast.success("Flight and hotel information updated.", {position:"top"})
				this.isBusy = false;
			}).catch((error) => {
				console.error("Error writing document: ", error);
				this.isBusy = false;
			})
			fb.adminEmailCollection.add({
				to: "secretariat@districtconference7030.com",
				message:{
					subject: `${orderData.data.fname} ${orderData.data.lname} - Hotel and flight information updated`,
					html:`<p>Dear Team,</p>
					<p>${orderData.data.fname} ${orderData.data.lname} has updated their hotel and flight information.</p>
					<p>Hotel: ${orderData.data.confhotel}</p>
					<p>Arrival: ${orderData.data.confairline1} ${orderData.data.confflight1}, ${orderData.data.confarrdate} ${orderData.data.confarrtime}</p>
					<p>Arrival: ${orderData.data.confairline2} ${orderData.data.confflight2}, ${orderData.data.confdepdate} ${orderData.data.confdeptime}</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p><hr/></p>
					<p style="font-size:10px;">${this.confInfo.confhost}</p>`,
				},
			}).then(()=>{
				this.isBusy = false;
			}).catch((error) => {
				console.error("Error writing document: ", error);
				this.isBusy = false;
			})
		},
    },
    mounted(){
		if(this.orderData) this.$store.dispatch("fetchConfProfile", this.orderData.data.confeventid);
    }
}
</script>
